import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    basePath: { type: String, default: "/admin/pipeline" },
  }

  connect() {
    this.initializeSortable()
  }

  initializeSortable() {
    this.element.querySelectorAll("[data-pipeline-column]").forEach((columnEl) => {
      Sortable.create(columnEl, {
        group: "pipeline",
        animation: 150,
        ghostClass: "opacity-40",
        dragClass: "shadow-lg",
        handle: ".pipeline-card",
        filter: ".pipeline-card-actions",
        preventOnFilter: true,
        onEnd: (evt) => this.onCardDropped(evt),
      })
    })
  }

  async onCardDropped(evt) {
    const card = evt.item
    const opportunityId = card.dataset.opportunityId
    const toStage = evt.to.dataset.stage

    if (!opportunityId || !toStage) return

    const fromStage = card.dataset.opportunityStage
    if (fromStage === toStage) return

    const url = `${this.basePathValue}/${opportunityId}/advance_stage?stage=${encodeURIComponent(toStage)}`
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
      })

      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.error || "Failed to update")
      }

      card.dataset.opportunityStage = toStage
      this.updateColumnCounts()
    } catch (err) {
      evt.from.insertBefore(card, evt.from.children[evt.oldIndex])
      this.showError(err.message)
    }
  }

  updateColumnCounts() {
    this.element.querySelectorAll("[data-pipeline-column]").forEach((col) => {
      const cards = col.querySelectorAll(".pipeline-card")
      const count = cards.length
      const totalCents = Array.from(cards).reduce((sum, card) => {
        return sum + (parseInt(card.dataset.opportunityValueCents || "0", 10) || 0)
      }, 0)
      const stageEl = col.closest("[data-pipeline-stage]")
      const countEl = stageEl?.querySelector("[data-pipeline-count]")
      const valueEl = stageEl?.querySelector("[data-pipeline-value]")
      if (countEl) countEl.textContent = count === 1 ? "1 opportunity" : `${count} opportunities`
      if (valueEl) valueEl.textContent = totalCents > 0 ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(totalCents / 100) : "—"
    })
  }

  showError(msg) {
    const toast = document.createElement("div")
    toast.className = "fixed bottom-4 right-4 px-4 py-2 rounded-lg bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-200 text-sm shadow-lg z-50"
    toast.textContent = msg
    document.body.appendChild(toast)
    setTimeout(() => toast.remove(), 4000)
  }
}
